import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/logo.svg'


const _hoisted_1 = { class: "footers-area pb-125 position-relative z-2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-3 col-sm-6" }
const _hoisted_5 = { class: "footer-single-item mb-4 ms-lg-5 ps-lg-4" }
const _hoisted_6 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_7 = { class: "mb-2 pb-1" }
const _hoisted_8 = { class: "mb-2 pb-1" }
const _hoisted_9 = { class: "mb-2 pb-1" }
const _hoisted_10 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-lg-3 col-sm-6\"><div class=\"footer-single-item mb-4\"><a href=\"#\" class=\"footer-logo d-inline-block mb-4\"><img src=\"" + _imports_0 + "\" alt=\"logo\"></a><p class=\"mb-4 pb-lg-2\"> With customizable dashboards tailored to your needs, collaborate effortlessly with your team and stay ahead with real-time updates. </p><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-3\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"text-decoration-none fs-20 text-primary\"><i class=\"ri-facebook-fill\"></i></a></li><li><a href=\"https://www.twitter.com/\" target=\"_blank\" class=\"text-decoration-none fs-20 text-primary\"><i class=\"ri-twitter-x-line\"></i></a></li><li><a href=\"https://www.linkedin.com/\" target=\"_blank\" class=\"text-decoration-none fs-20 text-primary\"><i class=\"ri-linkedin-fill\"></i></a></li><li><a href=\"https://www.dribbble.com/\" target=\"_blank\" class=\"text-decoration-none fs-20 text-primary\"><i class=\"ri-dribbble-line\"></i></a></li></ul></div></div><div class=\"col-lg-3 col-sm-6\"><div class=\"footer-single-item mb-4 ms-lg-5 ps-lg-5\"><h3 class=\"mb-md-4 mb-3 fw-semibold\">Our Products</h3><ul class=\"ps-0 mb-0 list-unstyled\"><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\">Trezo Dashboard</a></li><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\">Tagus Admin</a></li><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\">eCademy LMS</a></li><li class=\"mb-0\"><a href=\"#\" class=\"text-decoration-none\">Admash Template</a></li></ul></div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "mb-md-4 mb-3 fw-semibold" }, "Quick Links", -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_RouterLink, {
                  to: "/",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" Home ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_RouterLink, {
                  to: "/features",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Features ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/faq",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" FAQ ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: "/our-team",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Our Team ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"col-lg-3 col-sm-6\"><div class=\"footer-single-item mb-4\"><h3 class=\"mb-md-4 mb-3 fw-semibold\">Privacy Policy</h3><ul class=\"ps-0 mb-0 list-unstyled\"><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\">Terms &amp; Conditions</a></li><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\">Cookie Policy</a></li><li class=\"mb-2 pb-1\"><a href=\"#\" class=\"text-decoration-none\"> Notice at Collection </a></li><li class=\"mb-0\"><a href=\"#\" class=\"text-decoration-none\">Privacy Policy</a></li></ul></div></div>", 1))
      ])
    ])
  ]))
}